import React from "react";


function ErrorPane() {
    return (
        <div className="alert alert-danger m-3" role="alert">
            Something went wrong, wait and try again.
        </div>
    )
}

export default ErrorPane